import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WallpaperIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wallpaper"}/>
}
